import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import BreadCrumb from "../components/BreadCrumb";
import loginRight from "../assets/img/login-right.png";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import packageJson from '../../package.json';
import axios from "axios";

const BASE_URL = packageJson.apiUrl;
axios.defaults.withCredentials = true;

const MLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [forgotEmail, setForgotEmail] = useState("");
  const [forgotMessage, setForgotMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Show success message after reload if set in localStorage
    const msg = localStorage.getItem("forgotSuccessMessage");
    if (msg) {
      setSuccess(msg);
      localStorage.removeItem("forgotSuccessMessage");
    }
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    try {
      const response = await fetch(`${BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          email,
          password,
          remember: rememberMe,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Login failed.");
      }

      const data = await response.json();
      setSuccess("Login successful!");
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));

      const redirectTo = localStorage.getItem("redirectAfterLogin") || location.state?.from || "/";
      localStorage.removeItem("redirectAfterLogin");

      navigate(redirectTo);
      window.location.reload();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleForgotPassword = async () => {
    setForgotMessage("");

    try {
      const response = await fetch(`${BASE_URL}/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: forgotEmail }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message);
      }

      if (data.status === "success") {
        const modalElement = document.getElementById("forgotModal");
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement) || new window.bootstrap.Modal(modalElement);
        modalInstance.hide();

        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) backdrop.remove();

        localStorage.setItem("forgotSuccessMessage", data.message);

        setForgotEmail("");
        setForgotMessage("");

        window.location.reload();
      } else {
        throw new Error(data.message || "Failed to send reset link.");
      }
    } catch (err) {
      setForgotMessage(err.message);
    }
  };

  return (
    <div>
      <BreadCrumb />
      <section className="login-page section-space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="login-box">
                <div className="row g-0">
                  <div className="col-lg-6">
                    <div className="login-left">
                      <h2 className="login-title">Login</h2>
                      <p className="d-p">
                        Don't have an account? <Link to="/register">Register</Link>
                      </p>
                      {error && <p style={{ color: "red" }}>{error}</p>}
                      {success && <p style={{ color: "green" }}>{success}</p>}
                      <form onSubmit={handleLogin}>
                        <div className="form-group">
                          <label className="label-top">Email ID</label>
                          <input
                            className="form-control"
                            type="text"
                            placeholder="Enter Email ID"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label className="label-top">Password</label>
                          <input
                            className="form-control"
                            type="password"
                            placeholder="Enter Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>
                        <div className="row">
                          <div className="col-6">
                            <div className="form-group">
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="flexCheckDefault"
                                  checked={rememberMe}
                                  onChange={(e) => setRememberMe(e.target.checked)}
                                />
                                <label className="form-check-label" htmlFor="flexCheckDefault">
                                  Remember Me
                                </label>
                              </div>
                            </div>
                          </div>
                          <div className="col-6 text-end">
                            <a
                              href="#"
                              data-bs-toggle="modal"
                              data-bs-target="#forgotModal"
                              className="forgot-link"
                            >
                              Forgot Password?
                            </a>
                          </div>
                        </div>
                        <div className="form-group text-center">
                          <button type="submit" className="btn btn-green">
                            Login
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="login-right">
                      <img src={loginRight} className="img-fluid" alt="Login visual" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Forgot Password Modal */}
      <div
        className="modal fade modal-forgot"
        id="forgotModal"
        tabIndex="-1"
        aria-labelledby="forgotModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <h5 className="modal-title" id="forgotModalLabel">
                Forgot Password?
              </h5>
              <p>Please enter your email address to reset your password</p>
              <div className="form-group">
                <input
                  type="email"
                  id="resetEmail"
                  className="form-control"
                  placeholder="Enter your email"
                  value={forgotEmail}
                  onChange={(e) => setForgotEmail(e.target.value)}
                />
              </div>
              {forgotMessage && (
                <p style={{ color: "red", marginTop: "10px" }}>{forgotMessage}</p>
              )}
              <button
                type="button"
                className="btn btn-green w-100"
                onClick={handleForgotPassword}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MLogin;
